import { postFavoriteMarket } from './postFavoriteMarket';
import { removeFavoriteMarket } from './removeFavoriteMarket';
import { getFavoriteMarketsWithNewGoods } from './getFavoriteMarketsWithNewGoods';
import { getFavoriteMarketsFilterOptions } from './getFavoriteMarketsFilterOptions';
import { getFavoriteMarketsGoods } from './getFavoriteMarketsGoods';
import { getFavoriteMarkets } from './getFavoriteMarkets';

/**
 * - 최근본 상품의 찜관련 관련 api
 */
export const favoriteMarketService = {
  post: postFavoriteMarket,
  delete: removeFavoriteMarket,
  getFavoriteMarkets,
  getWithNewGoods: getFavoriteMarketsWithNewGoods,
  getFilterOptions: getFavoriteMarketsFilterOptions,
  getGoods: getFavoriteMarketsGoods,
};
